
export function getDirectoryTypeName(directoryType) {
    return directoryType === 'AD' ? 'Active Directory' : directoryType === 'AZURE' ? 'Azure AD' : directoryType === 'LDAP' ? 'LDAP Directory' : 'Directory';
}

export function toDirectoryDTO(directory) {
    return {...directory, 
        typeNameShort: directory.type === 'AZURE' ? 'AZURE AD' : directory.type,
        typeName: getDirectoryTypeName(directory.type),
        isAD: directory.type === 'AD',
        isLDAP: directory.type === 'LDAP',
        isAzure: directory.type === 'AZURE'
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/directory-integration.functions.js